<template>
  <div style="margin-bottom: 2rem;">
<!--
    <owal-button-toggle
      :segments="toggleSegments"
      @change="setMinConfidenceLevel"
      :defaultIndex="2"
      />
-->
    <faces-details-histogram-entry
      v-for="(entry) in visibleHistory"
      :key="entry.detection_id"
      :entry="entry"
      />
    <div key="histogram-expander-button" class="owal histogram staff expander">
      <div
        v-if="hasEnoughEventsToShowExpandButton"
        class="button"
        style="text-align: center; justify-content: center; margin-bottom: 0.5rem;"
        @click="toggleShowAll"
        >
        {{ toggleButtonTitle }}
      </div>
      <div
        v-else
        class="footer-title"
        style="text-align: center; justify-content: center; margin-bottom: 0.5rem;"
        >
        Showing All Detections.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FacesDetailsHistogramEntry from './FacesDetailsHistogramEntry'
import { OwalButtonToggle } from '@/libraries/owal-ui'
export default {
  name: 'faces-histogram',
  props: {
    currentFaceUUID: {
      type: String,
    },
  },
  components: {
    FacesDetailsHistogramEntry,
    // eslint-disable-next-line
    OwalButtonToggle,
  },
  data () {
    return {
      minConfidenceLevel: 2,
      defaultVisibleEvents: 5,
      showAllDetections: false,
    }
  },
  methods: {
    setMinConfidenceLevel (index) {
      this.minConfidenceLevel = index
    },
    toggleShowAll () {
      this.showAllDetections = !this.showAllDetections
    },
  },
  computed: {
    ...mapGetters({
      entireHistory: 'facesModule/entireHistory',
      entireHistoryLength: 'facesModule/entireHistoryLength',
    }),
    toggleSegments () {
      return [{
        title: 'Low',
      },
      {
        title: 'Medium',
      },
      {
        title: 'High',
      }]
    },
    filteredHistory () {
      const history = this.entireHistory.filter(x => (x.is_track_step || x.match_confidence_level >= this.minConfidenceLevel || (x.bestMatch && x.bestMatch.match_confidence_level >= this.minConfidenceLevel)))
      return history
    },
    visibleHistory () {
      if (this.showAllDetections) {
        return this.filteredHistory
      } else {
        const trimLength = Math.min(this.defaultVisibleEvents, this.entireHistoryLength)
        return this.filteredHistory.slice(0, trimLength)
      }
    },
    hasEnoughEventsToShowExpandButton (state) {
      return this.defaultVisibleEvents < this.filteredHistory.length
    },
    toggleButtonTitle () {
      if (this.showAllDetections) {
        return `Show Just ${this.defaultVisibleEvents} Detections`
      } else return `Show ${this.minConfidenceLevel === 2 ? `All ${this.filteredHistory.length}` : `${this.filteredHistory.length} Filtered`} Detections`
    },
  },
}
</script>

<style>
.button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 2.0714285714rem;
  width: 100%;
  cursor: pointer;

  padding: 0;
  margin: 0 5px;

  font-size: 0.8571428571rem;
  font-family: 'Lato', 'Helvetica';

  border-radius: 10px;

  color: #9b9b9b;
}

.button:hover,
.button:active {
  background-color: #d8d8d8;
}

/* More history button. */
.owal.histogram.staff.expander {
  width: 100%;
  height: 7rem;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  text-align: center;
}

</style>
